__webpack_require__.p = "/skos-systematik-test/";